import { useMemo } from 'react';
import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import { Product } from '@/creditflowresearch/domain/Product';
import type { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';

export interface IProductFilter {
  id: string,
  abbreviation: string,
  queryName?: string,
  disabled?: boolean,
  tooltip?: string | React.ReactNode,
  displayName?: string,
  marketDataName?: string,
}

export const useCreateProductFilters = (): IProductFilter[] => {
  const { products: productsList } = useHeaderMenuContext();
  const {
    products: accessibleProductsIds,
    plan,
  } = useUserPlanContext();
  const granted = useAccessGrant();

  return useMemo<IProductFilter[]>(() => {
    return productsList
      .map((productData: IProduct) => {
        const product = Product.from(productData.id);
        if (!product) return null;

        return {
          id: product.getId(),
          abbreviation: product.getAbbreviation() as string,
          queryName: product.getAbbreviation() as string,
          displayName: productData.displayName,
          disabled: !granted && (!product.canAccess(accessibleProductsIds) || !UserPlan.isSatisfiedPremiumPlan(plan)),
          tooltip: productData.displayName,
          marketDataName: productData.marketDataName,
        };
      })
      .filter(Boolean) as IProductFilter[];
  }, [productsList, accessibleProductsIds, plan, granted]);
};
